module.exports = __webpack_public_path__ + "img/image_021.6fa3abf0.jpeg";